import React, { useEffect } from "react";
import { Link } from "react-router-dom";

/**
 * HTTP 410 Gone — KB Hallen event retired.
 *
 * The cancelled KB Hallen event does NOT redirect anywhere. This page
 * explains the resource is permanently gone and offers a neutral link
 * back to the active events hub so visitors from stale bookmarks or
 * crawlers never land on an empty SPA shell.
 *
 * SPA layer limitations:
 *   - A true HTTP 410 response is set at the webpack-dev-server middleware
 *     layer (craco.config.js) so the status line and headers are correct
 *     before the SPA renders. Production hosting must mirror the same rule
 *     at its own layer.
 *   - This component adds `<meta name="robots" content="noindex, nofollow,
 *     noarchive">` and a `410` `prerender-status-code` meta so crawlers
 *     that cannot read the status (e.g. because the hosting returns 200)
 *     still treat the page as gone.
 */
export default function KbHallenGone() {
  useEffect(() => {
    const prev = document.title;
    document.title = "410 Gone — DANAmark";
    const metas = [
      ["robots", "noindex, nofollow, noarchive"],
      ["prerender-status-code", "410"],
    ];
    const nodes = metas.map(([name, content]) => {
      const el = document.createElement("meta");
      el.setAttribute("name", name);
      el.setAttribute("content", content);
      document.head.appendChild(el);
      return el;
    });
    return () => {
      document.title = prev;
      nodes.forEach(n => n.parentNode && n.parentNode.removeChild(n));
    };
  }, []);

  return (
    <div className="container-x max-editorial py-24 md:py-32 text-center" data-testid="kbh-gone">
      <div className="label-mono text-terracotta text-[10px] tracking-[0.22em]">410 · GONE</div>
      <h1 className="mt-4 font-editorial text-4xl md:text-5xl tracking-tighter">
        This page is no longer available.
      </h1>
      <div className="mt-10">
        <Link to="/events" data-testid="kbh-gone-events-link"
              className="inline-flex items-center gap-2 border border-ink text-ink hover:bg-ink hover:text-white px-7 py-3.5 text-sm tracking-[0.16em] uppercase">
          See current events
        </Link>
      </div>
    </div>
  );
}
